// extracted by mini-css-extract-plugin
module.exports = {"video":"KagemaneAutoplayVideo_video__A9Gl6"};